import React from "react";
import Barcode from 'react-barcode';
import ProductLong_776 from "components/Labels/ProductLong_776";
import ProductLong_2291 from "components/Labels/ProductLong_2291";
import ProductLong_2940 from "components/Labels/ProductLong_2940";
import ProductLong_3186 from "components/Labels/ProductLong_3186";

/**
 * @param {Products_Object} product
 * @param visible
 */
export default ({product, visible = false, acquisition = null}) => {
	switch (product.label) {
		case 776:
		case '776':
			return (<ProductLong_776 product={product} visible={visible}/>);
		case 2291:
		case '2291':
			return (<ProductLong_2291 product={product} visible={visible}/>);
		case 2940:
		case '2940':
			return (<ProductLong_2940 product={product} visible={visible}/>);
		case 3186:
		case '3186':
			return (<ProductLong_3186 product={product} visible={visible} acquisition={acquisition}/>);
	}

	let maxCharacters = 12;
	let minCharacters = 5;

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.6;
		let largest = 2.5;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	let value = product.id ? product.id : ('P-'+parseInt(product.binary_id.trim())+'-'+product.pkey);

	return (
		<div className="ProductLong" style={{
			textAlign:"center",
			width: '285px',
			height: '382px',

			... visible ? {
				border: '1px solid black',
				borderRadius: '10px',
				display: 'inline-block'
			} : {
				pageBreakBefore: 'always',
				
				marginLeft:"1px",
			}
		}}>
			<div style={{ borderBottom : '2px solid black'}}>
				<div className="serialNumber" style={{padding: '60px 0 10px 0', fontSize:'20px'}}>
					{product.serial_number}
				</div>
				<div className="barCode">
					<Barcode format={'CODE128A'}
					         value={cutBarCodeText(value)}
					         height={30}
					         margin={0}
					         width={getBarCodeWidth(value)}
					         displayValue={false} />
				</div>
				<b>{cutBarCodeText(value)}</b>{cutBarCodeTextExtra(value)}<br/>
			</div>

			<div className="notes" style={{padding:"10px 0 5px 0", marginBottom:'20px',fontSize:"16px",borderBottom : '2px solid black'}}>
				<div style={{marginBottom:'8px'}}>
					{product.importer && `${product.importer} / `}
					{!product.manufacturer_other && product.manufacturers ? product.manufacturers.name : product.manufacturer_other}
				</div>

				<div style={{marginBottom:'8px'}}>{product.model}</div>

				<div style={{marginBottom:'8px'}}>{!product.caliber_other && product.calibers ? product.calibers.name : product.caliber_other}</div>
				{product.barrel_length &&<div style={{marginBottom:'8px'}}> {product.barrel_length} inch barrel</div>}
				{product.tag_note && <div style={{marginBottom:'8px'}}>{product.tag_note}</div>}
			</div>

			{product.price_list && <span className="priceList" style={{fontSize:'30px',paddingTop:"60px"}}> Price : ${product.price_list}<br/></span>}
			<div className="pageBreak"/>
		</div>
	);
};
